<template>
	<div class="question">
		
		
		<div class="index-conent-left-connet1">
			<div class="list-div" v-for="(item,index) in list" :key="index">
				<router-link :to="'/topic/beaker?id='+item.id">
				<div class="list-div-titleh2">
					<div>{{item.name}}</div>
					<div>ID：{{item.id}}</div>
				</div>
				<div class="img_png" v-if="hide==1">
					<div @click="img_png_actionClick(0)" :class="img_png_action==0? 'img_png_action':''">
						<img src="../../assets/shudo/images/u187.png" />
					</div>
					<div @click="img_png_actionClick(1)" :class="img_png_action==1? 'img_png_action':''">
						<img src="../../assets/shudo/images/u186.png" />
					</div>
					<div @click="img_png_actionClick(2)" :class="img_png_action==2? 'img_png_action':''">
						<img src="../../assets/shudo/images/u188.png" />
					</div>
				</div>
				<img style="height: 8rem;" v-on:mouseover="changeActive($event)" v-on:mouseout="removeActive($event)" :src="item.img" />
				<div class="list-div-bao1">
					<div>难易度</div>
					<div>
						
						<img v-if="item.difficulty>=1" src="../../assets/shudo/images/11.svg" />
						<img v-if="item.difficulty>=2" src="../../assets/shudo/images/11.svg" />
						<img v-if="item.difficulty>=3" src="../../assets/shudo/images/11.svg" />
						<img v-if="item.difficulty>=4" src="../../assets/shudo/images/11.svg" />
						<img v-if="item.difficulty>=5" src="../../assets/shudo/images/11.svg" />
						
					</div>
				</div>
				<div class="list-div-top1">
					<div style="flex: 3;">
						<img :src="item.merchant.avatar" />
						<div>{{item.merchant.username}}</div>
					</div>
					<div>
						<!-- <img src="../../assets/shudo/images/10.svg" /> -->
						<!-- <div>20</div> -->
					</div>
				</div>
				</router-link>	
			</div>
		</div>
	</div>
	
</template>

<script>
	export default {
		data() {
			return {
				tab: 0,
				img_png_action :0,
				hide :  0,
				sponsor_id : '',
				list : []
			}
		},
		created() {
			var  query = this.$route.query;
			if(query.sponsor_id){
				this.sponsor_id = query.sponsor_id;
				this.getlist();
			}
		},
		methods:{
			tabClick(e){
				this.tab = e;
			},
			img_png_actionClick(e){
				this.img_png_action = e;
			},
			changeActive($event){
				$event.currentTarget.className="active";
			},
			removeActive($event){
				$event.currentTarget.className="";
			},
			getlist(){
				let that = this;
				that.$http('get','/api/v1/classify/hotTlist?sponsor_id='+that.sponsor_id,{}) .then(function (res) {
					that.list = res.data.list;
				});
			},

		},
	}
</script>

<style lang="less">
	.question {
		width: 100%;
		min-height: 25rem;
		color: #7F7F7F;
		
		.index-conent-left-connet1{
			min-height: 14rem;
			display: flex;
			margin-top: 1rem;
			flex-wrap: wrap;
			.list-div {
				border-radius: 0.4rem;
				min-height: 9.5rem;
				background-color: #FFFFFF;
				margin-left: 1rem;
				margin-right: 1rem;
				margin-top: 0.6rem;
				margin-bottom: 0.6rem;
				width: 10rem;
				font-size: 0.5rem;
				img {
					display: block;
					margin: auto;
					width: 90%;
				}
				.img_png {
					margin-left: 0.5rem;
					background-color: rgba(9, 7, 35, 0.788235294117647);
					width: 9rem;
					position: absolute;
					bottom: 6.2rem;
					height: 9rem;
					div {
						margin-top: 0.6rem;
						width: 100%;
						height: 2.2rem;
						img {
							padding-top: 0.1rem;
							width: 1.8rem;
						}
					}
					.img_png_action {
						background-color: rgba(9, 7, 35, 0.807843137254902);
					}
				}
				.list-div-titleh2 {
					height: 1.5rem;
					padding-left: 0.6rem;
					line-height: 1.5rem;
					font-size: 0.2rem;
					display: flex;
					div:nth-last-child(1){
						margin-left: auto;
						padding-right: 0.3rem;
						color: #878787;
					}
				}
				.list-div-title {
					padding-top: 0.3rem;
					padding-left: 0.6rem;
					display:flex;
					img {
						width: 22px;
						margin-left: 0;
					}
					div:nth-last-child(2){
						line-height: 2rem;
						flex:1;
						padding-left: 0.2rem;
						color: #181818c4;
					}
					div:nth-last-child(1){
						line-height: 2rem;
						flex:1;
						font-size: 0.5rem;
					}
				}
				.list-div-bao {
					padding-top: 0.1rem;
					padding-left: 0.6rem;
					color: #181818c4;
					font-size: 0.3rem;
				}
				.list-div-bao1{
					padding-top: 0.1rem;
					padding-left: 0.6rem;
					color: #181818c4;
					font-size: 0.3rem;
					display: flex;
					div:nth-last-child(2){
						width: 30%;
					}
					div:nth-last-child(1){
						display: flex;
						
						img{
							width: 10px;
						}
					}
				}
				.list-div-top {
					padding-top: 0.1rem;
					line-height: 1.5rem;
					display: flex;
					height: 2rem;
					div:nth-last-child(2){
						padding-left: 0.6rem;
						font-size: 0.5rem;
						flex:3;
					}
					div:nth-last-child(1){
						flex: 1;
						color: #d9001b;
						text-align: right;
						padding-right: 4px;
						font-size: 0.8rem;
					}
				}
				.list-div-top1 {
					padding-top: 0.1rem;
					line-height: 1.5rem;
					display: flex;
					height: 2rem;
					div:nth-last-child(2){
						flex:1;
						display: flex;
						padding-left: 0.6rem;
						line-height: 2rem;
						img{
							width: 20px;
						}
						div {
							padding-left: 0.2rem;
						}
					}
					div:nth-last-child(1){
						flex:1;
						display: flex;
						margin-right: auto;
						line-height: 2rem;
						padding-left: 2.3rem;
						color: #d9001b;
						img{
							width: 16px;
						}
						div {
							padding-left: 0.2rem;
						}
						
					}
				}
			}
		}
	}
</style>
